// import { startsWith } from "lodash";

// TODO : Add REST mode
export default function getFactory<TAjax>(ajax: TAjax): TAjax {
    // const isMobile = startsWith(window.location.hostname, "m.");
    // const mode = isMobile ? "rest" : "ajax";

    return ajax;
    // return rest;
}

export type Payload<T = unknown> = T & { signal?: AbortSignal };
